/* 新配色公告弹窗
   DOM 与文案全部由 sections/obsidian-announcement.liquid 输出，本文件只处理交互：
   - 首次进站延迟自动弹出（每个会话最多一次）
   - 关闭 / 点 CTA 后写入冷却期，冷却内只显示左下角 launcher
   - 关闭动画：把 dialog 缩小平移到 launcher 位置（--obs-min-x/y）
   - 无障碍：Esc 关闭、Tab 焦点循环、焦点返还、锁 body 滚动
*/
(function () {
  var reduced = window.matchMedia('(prefers-reduced-motion: reduce)');
  var designMode = !!(window.Shopify && window.Shopify.designMode);

  function readStore(api, key) {
    try {
      return window[api].getItem(key);
    } catch (e) {
      return null;
    }
  }

  function writeStore(api, key, value) {
    try {
      window[api].setItem(key, value);
    } catch (e) {
      /* 隐私模式下不可用，本次访问内的会话规则仍然生效 */
    }
  }

  // 让浏览器先应用初始态再加过渡 class。刻意不用 requestAnimationFrame：
  // 后台标签页的 rAF 会被冻结，弹窗会卡在「已锁滚动但不可见」的状态。
  function forceReflow(el) {
    return el.offsetHeight;
  }

  function track(eventName, root, source) {
    var payload = {
      event_category: 'Announcement',
      event_label: root.dataset.obsColorway || '',
      open_source: source || 'auto'
    };
    if (typeof window.gtag === 'function') {
      window.gtag('event', eventName, payload);
    } else if (window.dataLayer && typeof window.dataLayer.push === 'function') {
      window.dataLayer.push(Object.assign({ event: eventName }, payload));
    }
  }

  function init(root) {
    var overlay = root.querySelector('[data-obs-overlay]');
    var dialog = root.querySelector('[data-obs-dialog]');
    var launcher = root.querySelector('[data-obs-launcher]');
    var closeBtn = root.querySelector('[data-obs-close]');
    var cta = root.querySelector('[data-obs-cta]');
    if (!overlay || !dialog || !launcher) return;

    var storageKey = root.dataset.obsStorageKey || 'tp-announcement';
    var sessionKey = storageKey + '-session';
    var dayMs = 24 * 60 * 60 * 1000;
    var closeCooldown = parseInt(root.dataset.obsCloseDays, 10) * dayMs;
    var ctaCooldown = parseInt(root.dataset.obsCtaDays, 10) * dayMs;
    var autoDelay = parseInt(root.dataset.obsAutoDelay, 10);

    var lastFocused = null;
    var previousOverflow = '';
    var openSource = 'auto';
    var closeTimer = 0;
    var launcherTimer = 0;
    var receiveTimer = 0;

    function inCooldown() {
      var raw = readStore('localStorage', storageKey);
      if (!raw) return false;
      try {
        var parsed = JSON.parse(raw);
        return !!parsed.expiresAt && parsed.expiresAt > Date.now();
      } catch (e) {
        return false;
      }
    }

    function setCooldown(duration, action) {
      if (designMode || !duration) return;
      writeStore(
        'localStorage',
        storageKey,
        JSON.stringify({ action: action, expiresAt: Date.now() + duration })
      );
      writeStore('sessionStorage', sessionKey, '1');
    }

    function showLauncher(options) {
      var receive = !!(options && options.receive) && !reduced.matches;
      launcher.hidden = false;
      if (receive) launcher.classList.add('is-receiving');
      forceReflow(launcher);
      launcher.classList.add('is-visible');
      window.clearTimeout(receiveTimer);
      if (receive) {
        receiveTimer = window.setTimeout(function () {
          launcher.classList.remove('is-receiving');
        }, 820);
      }
    }

    function focusables() {
      return Array.prototype.slice.call(
        dialog.querySelectorAll('a[href], button:not([disabled]), [tabindex]:not([tabindex="-1"])')
      );
    }

    function open(source) {
      window.clearTimeout(closeTimer);
      window.clearTimeout(launcherTimer);
      window.clearTimeout(receiveTimer);
      openSource = source || 'launcher';
      lastFocused = openSource === 'launcher' ? launcher : document.activeElement;
      launcher.classList.remove('is-visible', 'is-receiving');
      launcher.hidden = true;
      overlay.classList.remove('is-minimizing');
      dialog.style.removeProperty('--obs-min-x');
      dialog.style.removeProperty('--obs-min-y');
      overlay.hidden = false;
      overlay.setAttribute('aria-hidden', 'false');
      previousOverflow = document.body.style.overflow;
      document.body.style.overflow = 'hidden';
      forceReflow(overlay);
      overlay.classList.add('is-open');
      dialog.focus({ preventScroll: true });
      track(openSource === 'auto' ? 'announcement_view' : 'announcement_reopen', root, openSource);
    }

    function close(options) {
      var opts = options || {};
      if (overlay.hidden || overlay.classList.contains('is-minimizing')) return;
      overlay.setAttribute('aria-hidden', 'true');
      document.body.style.overflow = previousOverflow;
      if (opts.cooldown !== false) setCooldown(closeCooldown, 'minimized');
      track('announcement_minimize', root, openSource);

      function finish() {
        overlay.classList.remove('is-open', 'is-minimizing');
        overlay.hidden = true;
        dialog.style.removeProperty('--obs-min-x');
        dialog.style.removeProperty('--obs-min-y');
        if (!launcher.classList.contains('is-visible')) {
          showLauncher({ receive: true });
        }
        if (opts.restoreFocus !== false && lastFocused && lastFocused.focus) {
          lastFocused.focus({ preventScroll: true });
        }
      }

      if (reduced.matches) {
        overlay.classList.remove('is-open');
        closeTimer = window.setTimeout(finish, 40);
        return;
      }

      // 先把 launcher 放到最终位置量出中心点，再让 dialog 朝它缩过去
      launcher.hidden = false;
      launcher.classList.remove('is-visible', 'is-receiving');
      var dialogRect = dialog.getBoundingClientRect();
      var launcherRect = launcher.getBoundingClientRect();
      dialog.style.setProperty(
        '--obs-min-x',
        launcherRect.left + launcherRect.width / 2 - (dialogRect.left + dialogRect.width / 2) + 'px'
      );
      dialog.style.setProperty(
        '--obs-min-y',
        launcherRect.top + launcherRect.height / 2 - (dialogRect.top + dialogRect.height / 2) + 'px'
      );
      overlay.classList.add('is-minimizing');

      launcherTimer = window.setTimeout(function () {
        showLauncher({ receive: true });
      }, 390);
      closeTimer = window.setTimeout(finish, 590);
    }

    if (closeBtn) closeBtn.addEventListener('click', function () { close(); });
    launcher.addEventListener('click', function () { open('launcher'); });
    overlay.addEventListener('click', function (event) {
      if (event.target === overlay) close();
    });

    if (cta) {
      cta.addEventListener('click', function () {
        // 埋点由 theme.js 的 [data-track-event] 委托处理，这里只写冷却并让弹窗让位跳转
        setCooldown(ctaCooldown, 'cta');
        overlay.classList.remove('is-open');
        overlay.setAttribute('aria-hidden', 'true');
        document.body.style.overflow = previousOverflow;
      });
    }

    document.addEventListener('keydown', function (event) {
      if (overlay.hidden) return;
      if (event.key === 'Escape') {
        event.preventDefault();
        close();
        return;
      }
      if (event.key !== 'Tab') return;
      var items = focusables();
      if (!items.length) {
        event.preventDefault();
        dialog.focus();
        return;
      }
      var first = items[0];
      var last = items[items.length - 1];
      if (event.shiftKey && document.activeElement === first) {
        event.preventDefault();
        last.focus();
      } else if (!event.shiftKey && document.activeElement === last) {
        event.preventDefault();
        first.focus();
      }
    });

    // 编辑器里始终只显示 launcher，方便选中 section 调内容，不自动弹、不写 storage
    if (designMode) {
      showLauncher();
      return;
    }

    if (readStore('sessionStorage', sessionKey) === '1' || inCooldown()) {
      showLauncher();
      return;
    }

    writeStore('sessionStorage', sessionKey, '1');
    window.setTimeout(function () {
      if (overlay.hidden) open('auto');
    }, isNaN(autoDelay) ? 2000 : autoDelay);
  }

  document.querySelectorAll('[data-obs-root]').forEach(init);
})();
